export default __webpack_public_path__ + "static/head-app-9823ae0b7b059eb636934466223fbe4e.jpg";